// extracted by mini-css-extract-plugin
export default {"graph":"WisdomGraph_graph__2bnAQ","apexcharts-toolbar":"WisdomGraph_apexcharts-toolbar__6wCiE"};